/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useId, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import { IOMService } from '../../apis/apiServices/InterOfficeMemo(IOM)'
import { getReduxCompany } from "../../helper/sessionHelper";

export default function SidebarComponent() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const controller = new AbortController();
  const divRef = useRef(null); // Ref to access the div
  const iomPendingCount = useSelector((state) => state.iomPendingCount.count);

  const featureMenu = useSelector((state) => state?.featureMenu?.data);

  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector((state) => state.user.data);
  const [iomList, setIOMList] = useState(null);
  const [pendingIOMCount, setPendingIOMCount] = useState(null);

  const toggleMenu = () => {
    setIsOpen(prev => !prev);
  };

  const getIOMList = async () => {
    try {
      let body = {
        UserId: user.userId,
        //fromDate: (filters?.fromDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.fromDate) : null,
        //toDate: (filters?.toDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.toDate) : null,
      }
      const response = await IOMService.getIOMList(body)
      const filteredData = response?.data?.filter(
        item => item?.nextUserId === user?.userId && item?.iomStatusId !== 4
      );
      const filteredCount = filteredData?.length;
      setPendingIOMCount(filteredCount);
      setIOMList(response?.data);
      //getFilteredList([8, 4], response?.data)
      return response?.data;
    } catch (error) {
      console.log("Error getIOMList===>", error);
    }
  }



  const handleBackToVishwam = (appUrl) => {
    let companyId = getReduxCompany()?.id || 0;
    const queryParams = new URLSearchParams({ companyId: Number(companyId) }).toString();

    const fullUrl = `${appUrl}?${queryParams}`;

    // window.open(fullUrl, '_blank');
    window.location.href = fullUrl;
  };

  const spreadFeaturesInModule = (module) => {
    if ((module?.featureList && module?.featureList?.length)) {

      return (
        <div className="card"> {module?.featureList?.map((feature, featureIndex) => {
          return (<Link
            to={feature?.pageUrl || ""}
            className={`nav-link ${isActive(feature?.pageUrl) ? 'active' : ''}`}
          >
            <Icon icon={feature?.icon} className="iconify-size" /><p>{feature?.featureName}</p>
          </Link>);
        })
        }
        </div>
      )
    }
  }

  const spreadFeatureMenu = (featureMenuModule, isOuterModule) => {
    // const recursionFunction = spreadFeatureMenu;

    return (
      featureMenuModule?.map((module, index) => {
        return (
          <>
            {
              (isOuterModule)
                ? <>
                  <li class="nav-header text-white">
                    {/* <Icon icon={module?.icon} className="iconify-size" /> */}
                    &nbsp;{module?.moduleName}
                  </li>

                  {(module?.moduleList && module?.moduleList?.length) ? spreadFeatureMenu(module?.moduleList, false) : ""}

                  <div className="card">
                    {spreadFeaturesInModule(module)}
                  </div>
                </>
                : <div className="card">
                  <div className="card-header nav-link" id={`_faqhead${index + 1}`}>
                    <a
                      href="#"
                      className="nav-link collapsed"
                      data-toggle="collapse"
                      data-target={`#_${module?.moduleId}`}
                      aria-expanded={false}
                      aria-controls={`_faqhead${index + 1}`}
                    >
                      <Icon icon={module?.icon} className="iconify-size" /><p>{module?.moduleName}</p>
                    </a>
                  </div>
                  {
                    <div id={"_" + module?.moduleId} className="collapse" aria-labelledby={`_faqhead${index + 1}`} data-parent="#faq" >
                      <div className="card-body p-0">
                        <ul className="nav nav-treeview" style={{ display: "block" }} >
                          <div className="card">
                            {spreadFeaturesInModule(module)}
                          </div>
                        </ul>
                      </div>
                    </div>
                  }
                  {(module?.moduleList && module?.moduleList?.length) ? spreadFeatureMenu(module?.moduleList, false) : ""}
                </div>
            }
          </>
        )
      })
    )
  }

  useEffect(() => {
    getIOMList();
    return () => {
      controller.abort();
    };
  }, []);

  return (
    <>
      <aside
        ref={divRef}
        className="main-sidebar sidebar-dark-primary"
      >
        <Link href="/" className="brand-link">
          <img
            src="./assets/img/icon-digilinkz.png"
            alt="DigilinkZ"
            className="brand-image"
          />
          <span className="brand-text">

            <img
              src="./assets/img/logo-text-digilinkz.png" style={{ position: 'relative', top: '0px' }}
              className="img-fluid logo-brand-image"
            />
          </span>
          <span className="version ml-1" style={{ color: '#b98f3b' }}>v {process.env.REACT_APP_VERSION}</span>
        </Link>

        {/* Dynamic Menu */}
        {true
          && <div className="sidebar">
            <nav>
              <ul
                className="nav nav-sidebar flex-column"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                <div id="main">
                  <div className="accordion" id="faq">
                    <div className="card" title="Go to VISHWAM" style={{ backgroundColor: '#000000', color: 'white', padding:'1.2rem 0rem' }}>
                      {/* <span className="nav-link pt-1 pb-1">
                        <img src="./assets/img/logo-symbol-vishwam.png" alt="VISHWAM" width="30px" />&nbsp;<p>Go to VISHWAM</p>
                        </span> */}
                    </div>

                    {spreadFeaturesInModule({ featureList: featureMenu?.featureList })}
                    {spreadFeatureMenu(featureMenu?.moduleList, true)}

                  </div>
                </div>
              </ul>
            </nav>
          </div>
        }

        {/* Static Menu */}
        {false
          && <div className="sidebar">
            <nav>
              <ul
                className="nav nav-sidebar flex-column"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                <div id="main">
                  <div className="accordion" id="faq">
                    <div className="card" title="Go to VISHWAM" style={{ backgroundColor: '#B68E2D', color: 'white' }} onClick={() => { window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL }} >
                      <span className="nav-link pt-2 pb-2"><img src="./assets/img/logo-symbol-vishwam.png" alt="VISHWAM" width="30px" className="img-circle p-1" style={{ backgroundColor: '#282C7D ' }} />&nbsp;<p>Go to VISHWAM</p></span>
                    </div>
                    <div className="card">
                      <Link
                        to="/dashboard"
                        className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
                        title="Dashboard"
                      >
                        <Icon icon="si:dashboard-line" className="iconify-style" />
                        <p>Dashboard</p>
                      </Link>
                    </div>
                    <li class="nav-header text-white">DOCUMENT</li>
                    <div className="card">
                      {/* <Link to="/documents" className="nav-link"> <i className="fas fa-circle nav-icon" /><p>Documents</p> </Link> */}
                      <Link
                        to="/pending-ioms"
                        className={`nav-link ${isActive('/pending-ioms') ? 'active' : ''}`}
                        title="Pending IOMs"
                      >
                        <Icon className="iconify-style" icon="ph:clock-user" />
                        <p>My Tasks</p>
                      </Link>
                      <Link
                        to="/inter-office-memo"
                        className={`nav-link ${isActive('/inter-office-memo') ? 'active' : ''}`}
                        title="Inter Office Memorandum"
                      >
                        <Icon className='iconify-style' icon="lsicon:user-crowd-outline" />
                        <p>Inter Office Memorandum</p>
                      </Link>
                      {/* <Link to="/minutes-of-meeting" className="nav-link"> <i className="fas fa-circle nav-icon" /><p>MOM</p> </Link> */}

                      {/* <Link to="/pending-ioms" className="nav-link" title="Pending IOMs"><Icon className='iconify-style mr-1' icon="ph:clock-user" /> <p>Pending IOMs
                      &nbsp;
                      {(iomPendingCount > 0 || pendingIOMCount > 0) && (
                        <span
                          className="badge badge-danger"
                          style={{ verticalAlign: 'middle' }}
                        >
                          {iomPendingCount === 0 ? pendingIOMCount : iomPendingCount}
                        </span>
                      )}

                      <span className="badge badge-danger" style={{ verticalAlign: 'middle' }}>{iomPendingCount === 0 ? pendingIOMCount : iomPendingCount}</span>
                    </p>
                    </Link> */}
                    </div>
                    <li class="nav-header text-white">CONFIGURATION</li>
                    <div className="card">
                      {/* <Link to="/TESTT" className="nav-link"> <i className="fas fa-circle nav-icon" /><p>tEST PRINT</p> </Link> */}
                      <Link
                        to="/inter-office-memo-configuration"
                        className={`nav-link ${isActive('/inter-office-memo-configuration') ? 'active' : ''}`}
                        title="IOM Approver"
                      >
                        <Icon className='iconify-style' icon="lsicon:user-crowd-outline" />
                        <p>IOM Approver</p>
                      </Link>

                      {/* <Link to="/inter-office-memo-configuration" className="nav-link" title="IOM Approver"><Icon className='iconify-style mr-1' icon="lsicon:user-crowd-outline" /> <p>IOM Approver</p> </Link> */}
                      {/* <Link to="/minutes-of-meeting" className="nav-link"> <i className="fas fa-circle nav-icon" /><p>MOM</p> </Link> */}
                    </div>
                    {/* <div className="card">
                    <Link to="/report" className="nav-link" title="Report"><Icon className='iconify-size mr-1' icon="hugeicons:filter" /> <p>Report</p> </Link>
                  </div> */}
                  </div>
                </div>
              </ul>
            </nav>
          </div>
        }

      </aside>
    </>
  );
}
